function increaseQuantity() {
  const quantityInput = document.querySelector('input[name="quantity"]');
  quantityInput.value = parseInt(quantityInput.value) + 1;
}

function decreaseQuantity() {
  const quantityInput = document.querySelector('input[name="quantity"]');
  if (parseInt(quantityInput.value) > 1) {
    quantityInput.value = parseInt(quantityInput.value) - 1;
  }
}

function updateVariant() {
  const selectedOptions = {};

  document.querySelectorAll('.variant-option:checked').forEach(input => {
    const optionName = input.name.replace('options[', '').replace(']', '');
    selectedOptions[optionName] = input.value;
  });

  const selectedVariant = window.productData.variants.find(variant => {
    return window.productData.options.every((option, index) => {
      const optionKey = `option${index + 1}`;
      const selectedValue = selectedOptions[option.name];
      return !selectedValue || variant[optionKey] === selectedValue;
    });
  });

  // Update hidden variant ID input
  if (selectedVariant) {
    const variantIdInput = document.getElementById('variant-id');
    if (variantIdInput) {
      variantIdInput.value = selectedVariant.id;
    }

    // Update Add to Cart button based on availability
    const addToCartBtn = document.querySelector('.add-to-card-btn .btn');
    if (addToCartBtn) {
      if (!selectedVariant.available) {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('sold-out');
        const svgIcon = addToCartBtn.querySelector('svg');
        addToCartBtn.innerHTML = '';
        if (svgIcon) addToCartBtn.appendChild(svgIcon);
        addToCartBtn.appendChild(document.createTextNode(' Sold Out'));
        const span = document.createElement('span');
        addToCartBtn.appendChild(span);
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('sold-out');
        const svgIcon = addToCartBtn.querySelector('svg');
        addToCartBtn.innerHTML = '';
        if (svgIcon) addToCartBtn.appendChild(svgIcon);
        addToCartBtn.appendChild(document.createTextNode(' add to cart'));
        const span = document.createElement('span');
        addToCartBtn.appendChild(span);
      }
    }
  }

  // Mark unavailable variant pills with disabled styling
  document.querySelectorAll('.variant-option').forEach(input => {
    const optionName = input.name.replace('options[', '').replace(']', '');
    const testOptions = { ...selectedOptions, [optionName]: input.value };

    const matchingVariant = window.productData.variants.find(variant => {
      return window.productData.options.every((option, index) => {
        const optionKey = `option${index + 1}`;
        return variant[optionKey] === testOptions[option.name];
      });
    });

    const wrapper = input.closest('.product-varient-input-field');
    if (!matchingVariant || !matchingVariant.available) {
      input.disabled = true;
      if (wrapper) wrapper.classList.add('disabled');
    } else {
      input.disabled = false;
      if (wrapper) wrapper.classList.remove('disabled');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const variantInputs = document.querySelectorAll('.variant-option');
  variantInputs.forEach(input => {
    input.addEventListener('change', updateVariant);
  });

  updateVariant();
});